import type { CategoryLocaleEntry, CategoryPageLocaleCopy } from '../types'

export const categoryPageCopyEs: CategoryPageLocaleCopy = {
  notFound: 'Categoria no encontrada',
  backHome: 'Volver al inicio',
  breadcrumbHome: 'Inicio',
  fallbackToolsTitle: 'Herramientas Online Gratis',
}

export const categoryContentEs: Partial<Record<string, CategoryLocaleEntry>> = {
  converters: {
    h1: '🔄 Convertidores',
    seoTitle: 'Convertidores Online Gratis - Unidades, JSON, Base64, CSV y URL',
    seoDescription: 'Convertidores online gratis para unidades, JSON/YAML, Base64, bases numericas, URL encoding y CSV/JSON.',
    intro: 'Convertidores rapidos para ingenieria, desarrollo y uso diario. Convierte unidades, transforma formatos y codifica o decodifica texto en segundos.',
  },
  tools: {
    h1: '🛠️ Herramientas',
    seoTitle: 'Herramientas Online Gratis - IP, Subred, Regex, Color, Hash y Timestamp',
    seoDescription: 'Herramientas online gratis: calculadora de subred, cual es mi IP, tester regex, convertidor de color y generador hash.',
    intro: 'Herramientas utiles para desarrollo y redes, gratis en tu navegador. Consulta tu IP, calcula subredes, prueba expresiones regulares y genera hashes.',
  },
  generators: {
    h1: '✨ Generadores',
    seoTitle: 'Generadores Online Gratis - Contrasenas, UUID y Lorem Ipsum',
    seoDescription: 'Generadores online gratis para contrasenas seguras, UUID y texto Lorem Ipsum.',
    intro: 'Genera contrasenas, UUID y texto de relleno al instante. Todo funciona en tu navegador sin enviar datos a servidores.',
  },
}
